import React, { createContext, useContext } from 'react';
var ClientHeaderContext = /*#__PURE__*/createContext();
export function ClientHeaderProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(ClientHeaderContext.Provider, {
    value: value
  }, children);
}
export function useClientHeader() {
  return useContext(ClientHeaderContext);
}
export function useAppState() {
  return useClientHeader().appState;
}
export function useAdapters() {
  return useClientHeader().adapters;
}
export function useCoreApi() {
  return useAdapters().coreApi;
}
//# sourceMappingURL=clientHeader.js.map